import React from 'react';

export default class EmptyShipments extends React.Component{
  render(){
    const {props} = this;
    return(
      <div className = "empty-shipments-wrap">
        <div className="shipment-empty-icon" style={{"backgroundImage": 'url("' + this.props.imgURL+ '")'}}>
        </div>
        <div className="empty-shipments-header">{props.title}</div>
        <div className="empty-shipments-elm">{props.info}</div>
        <div className="store-links">
          <a className="link" target="_blank" href="https://itunes.apple.com/us/app/airwaybill/id1198529029?ls=1&mt=8">
            <img className="playstore-img" src="../public/images/landing/appstore.png"/>
          </a>
          <a className="link" target="_blank" href="http://play.google.com/store/apps/details?id=com.awb.android">
            <img className="appstore-img" src="../public/images/landing/playstore.png"/>
          </a>
        </div>
      </div>
    )
  }
}
EmptyShipments.propTypes = {
  title: React.PropTypes.string.isRequired,
  info: React.PropTypes.string.isRequired,
  imgURL :React.PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// app/dashboard/empty_shipment.jsx